<template>
    <fragment>
        <custom-search
            placeholder="Buscar Servicio ..."
            :disabled="!enabled"
            :fetch-items="searchServices"
            @select="emitSelect"
            @focus="onFocusKeySearch"
            @blur="onBlur"
        >
            <template #item="{ item }">
                {{ item.product.name | cut(20) }} |
                {{ item.priceOffer | money }}
            </template>
            <template #footer>
                <button
                    type="button"
                    class="w-full text-left px-3 py-2 text-sm text-theme-base hover:bg-theme-hover border-t border-theme-border"
                    @click="addService"
                >
                    Agregar Servicio Nuevo
                </button>
            </template>
        </custom-search>

        <app-dialog v-model="isOpenNewService">
            <template #header>
                <span class="text-lg">
                    Agrega servicios o productos libres
                </span>
            </template>
            <div>
                <span>
                    Estas a punto de registrar una venta con un producto anómino
                    o una servicio no registrado. Recuerda solo deben de
                    registrase estas ventas para productos que no superen los $
                    COP 10.000 o en situaciones especiales, ingresa los
                    siguientes campos.
                </span>
                <div class="flex flex-wrap my-6 gap-4">
                    <custom-input
                        v-model="name"
                        class="w-full"
                        label="Concepto"
                        name="concept"
                        autocomplete="off"
                        @focus="onFocusConcept"
                    />
                    <input-money-component
                        v-model="priceOffer"
                        class="w-full"
                        enabled
                        label="Precio"
                        icon="💲"
                        @focus="onFocusName"
                    />
                </div>
                <div class="flex justify-center">
                    <app-button
                        icon
                        :disabled="!priceOffer || !name"
                        @click="pushAnonymousProduct"
                    >
                        <span class="text-lg"> &nbsp;Agregar ✔️ </span>
                    </app-button>
                </div>
            </div>
        </app-dialog>
    </fragment>
</template>

<script>
import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import CustomSearch from "@/components/utils/CustomSearch.vue";
import InputMoneyComponent from "@/components/utils/InputMoneyComponent.vue";

export default {
    name: "ServiceSelector",
    components: { AppDialog, InputMoneyComponent, CustomInput, CustomSearch },
    props: {
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        base: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    emits: ["blur", "focus", "input"],
    data: () => ({
        isOpenNewService: false,
        priceOffer: 1000,
        name: "No especifica concepto"
    }),
    methods: {
        async searchServices(keyword) {
            const keyLower = keyword.toLowerCase();
            return this.base.filter(
                (item, index) =>
                    `${item.name}`.toLocaleLowerCase().includes(keyLower) &&
                    index < 3
            );
        },
        onBlur() {
            this.$emit("blur");
        },
        onFocusKeySearch() {
            this.$emit("focus");
        },
        emitSelect(item) {
            this.$emit("input", { ...item, quantity: 1 });
        },
        addService() {
            this.isOpenNewService = true;
        },
        pushAnonymousProduct() {
            this.$emit("input", {
                quantity: 1,
                priceOffer: this.priceOffer,
                product: {
                    name: this.name
                }
            });
            this.isOpenNewService = false;
            this.name = "No especifica concepto";
        },
        onFocusConcept() {
            if (this.name === "No especifica concepto") {
                this.name = "";
            }
            this.$emit("focus");
        },
        onFocusName() {
            this.$emit("focus");
        }
    }
};
</script>
